import config from '../config';

export async function upsertUser(backendFetch, user, method = 'PUT') {
    const formData = new FormData();
    formData.append('user', JSON.stringify(user));
    await backendFetch(config.REACT_APP_HOST + '/api/v2/users', {
        method: method,
        body: formData,
    });
}

export async function updateMyUser(backendFetch, user, method = "PUT") {
  const formData = new FormData();
  formData.append("user", JSON.stringify(user));
    await backendFetch(config.REACT_APP_HOST + "/api/v2/profile/users", {
    method: method,
    body: formData,
  });
}

export async function updateUser(backendFetch, user, method = "PUT") {
  const formData = new FormData();
  formData.append("user", JSON.stringify(user));
    await backendFetch(config.REACT_APP_HOST + "/api/v2/admin/users", {
    method: method,
    body: formData,
  });
}

export async function createUser(backendFetch, user) {
  const formData = new FormData();
  formData.append("user", JSON.stringify(user));
    await backendFetch(config.REACT_APP_HOST + "/api/v2/users", {
    method: "POST",
    body: formData,
  });
}

export async function validateUserName(backendFetch, userName) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/users/validate?username=" + userName)
    const r = await f.json()
    return r.valid
}

export async function fetchUsers(backendFetch) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/users")
    if (f.status === 403) {
        return []
    }
    const r = await f.json()
    return r.users ? r.users : []
}

export async function validateResetPasswordTokenLink(backendFetch, link) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/users/reset-password-token/validate/" + link)
    const r = await f.json()
    return r
}

export async function requestResetPassword(backendFetch, username) {
    const formData = new FormData();
    formData.append('username', JSON.stringify(username));
    await backendFetch(config.REACT_APP_HOST + "/api/v2/users/reset-password-token/request", {
        method: 'POST',
        body: formData,
    });
}

export async function resetPasswordSubmit(backendFetch, user, method = 'PUT') {
    const formData = new FormData();
    formData.append('user', JSON.stringify(user));
    await backendFetch(config.REACT_APP_HOST + '/api/v2/users/reset-password-token/submit', {
        method: 'PUT',
        body: formData,
    });
}

export async function getTechnicalSupport(backendFetch) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/users/technical-support');
    const r = await f.json();
    return r.active || false;
}

export async function setTechnicalSupport(backendFetch, active) {
    const formData = new FormData();
    formData.append('active', active.toString());
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/users/technical-support', {
        method: 'PUT',
        body: formData,
    });
    const r = await f.json();

    // Check if the backend returned success: false
    if (r.success === false) {
        throw new Error(r.message || 'Failed to update technical support preference');
    }

    return r;
}
